import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent } from '../components/ui/card';
import { Building2, Book, TrendingUp, Users, Heart, Award, Target, Lightbulb } from 'lucide-react';

export const About = () => {
  const [team, setTeam] = useState([]);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
      const [teamRes, projectsRes] = await Promise.all([
        axios.get(`${BACKEND_URL}/api/team`),
        axios.get(`${BACKEND_URL}/api/projects`)
      ]);
      console.log('Team loaded:', teamRes.data);
      console.log('Projects loaded:', projectsRes.data);
      setTeam(teamRes.data || []);
      setProjects(projectsRes.data || []);
    } catch (error) {
      console.error('Error loading data:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen">
      <section className="bg-gradient-to-br from-blue-700 via-blue-800 to-indigo-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <Building2 className="h-20 w-20 mx-auto mb-6 text-blue-200" />
          <h1 className="text-5xl md:text-6xl font-extrabold mb-6" style={{fontFamily: 'Work Sans'}}>About Nigerland</h1>
          <p className="text-2xl text-blue-100 max-w-4xl mx-auto">Developing MEN, IDEAS & SOLUTIONS since 2000</p>
        </div>
      </section>

      {/* OUR COMPANY STORY */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center gap-4 mb-8 justify-center">
            <Book className="h-12 w-12 text-blue-700" />
            <h2 className="text-4xl font-bold">Our Story</h2>
          </div>
          <div className="prose prose-lg max-w-none space-y-6">
            <p className="text-gray-700 leading-relaxed text-lg">
              The CONSULTANTS who formed NIGERLAND, <strong>RECOGNIZING</strong> the importance of Human Capital, <strong>REALIZING</strong> the usefulness of training in shaping Man's decisions, <strong>CONSIDERING</strong> the overriding impact of Man's decisions on his Environment, <strong>DETERMINED</strong> to form a Consulting Consortium, <strong>AIMED</strong> at developing MEN, IDEAS & SOLUTIONS.
            </p>
            <p className="text-gray-700 leading-relaxed text-lg">
              Thus in year <strong>2000</strong>, under the leadership of <strong>Professor Francis Ngwaba</strong> (American Fulbright Scholar and Professor of English Literature), Nigerland was established.
            </p>
            <div className="bg-blue-50 border-l-4 border-blue-700 p-6 my-8">
              <p className="text-gray-800 text-lg font-semibold">
                Nigerland has partnered with tertiary institutions to train over <span className="text-blue-700 text-2xl font-bold">8,000 people</span> who have contributed their quota to the growth of the Nigerian economy.
              </p>
            </div>
            <p className="text-gray-700 leading-relaxed">
              Some of these institutions include <strong>The Polytechnic Calabar</strong>, <strong>Grace Polytechnic Surulere</strong> and <strong>Abia State University</strong>.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Nigerland has also trained for Corporate organizations such as <strong>Nigerian Airspace Management Agency</strong>, <strong>Federal Ministry of Mines and Steel Development</strong>, <strong>Cross River State Government</strong> (Office of the Wife of the Governor during the 2009 Calabar Children's Carnival).
            </p>
            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-8 rounded-2xl my-8">
              <p className="text-xl italic text-center leading-relaxed">
                "COMFORTABLE SEATERS BY THE FIRE SIDE CAN ONLY EAT MAIZE AND NOT OMLETTE."
              </p>
              <p className="text-center mt-4 text-blue-100">- Professor Francis Ngwaba (1937-2004)</p>
            </div>
          </div>
        </div>
      </section>

      {/* OUR PHILOSOPHY */}
      <section className="py-16 bg-gradient-to-br from-blue-50 to-indigo-50">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <Target className="h-16 w-16 mx-auto mb-4 text-blue-700" />
            <h2 className="text-4xl font-bold mb-4">Our Philosophy</h2>
          </div>
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <p className="text-xl text-gray-700 leading-relaxed mb-6">
              The underlying philosophy of the creation of NIGERLAND is the <strong className="text-blue-700">betterment of MAN AND HIS SOCIETY</strong>. Nigerland believes that if Man is properly developed then mankind can go and sleep.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Failure in governance is due to Man's failure. Failure in provision of health care facilities and social amenities is due to Man's failure. Man constantly fails himself. There is therefore the need to get IT RIGHT WITH MAN and as trainers, Consultants with Nigerland view man as a being that must be appreciated, cajoled, persuaded and loved.
            </p>
          </div>
        </div>
      </section>

      {/* LEADERSHIP TEAM */}
      <section id="team" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <Users className="h-16 w-16 mx-auto mb-4 text-blue-700" />
            <h2 className="text-4xl font-bold mb-4">Our Leadership Team</h2>
            <p className="text-xl text-gray-600">Led by excellence, driven by passion</p>
          </div>
          {loading ? (
            <div className="text-center py-12"><p>Loading team...</p></div>
          ) : (
            <div className="grid md:grid-cols-2 gap-12">
              {team.map(member => (
                <Card key={member.id} className="hover:shadow-2xl transition-all duration-300 border-t-4 border-t-blue-600">
                  <CardContent className="p-8">
                    <div className="flex flex-col md:flex-row gap-8">
                      <img 
                        src={member.image} 
                        alt={member.name} 
                        className="w-48 h-48 rounded-full object-cover shadow-xl mx-auto md:mx-0" 
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = '/images/team/placeholder.jpg';
                        }}
                      />
                      <div className="flex-1">
                        <h3 className="text-3xl font-bold mb-2">{member.name}</h3>
                        <p className="text-blue-700 font-semibold text-lg mb-4">{member.title}</p>
                        <p className="text-gray-700 leading-relaxed">{member.bio}</p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* NIGERLAND LOGISTICS & MARKETING */}
      <section className="py-20 bg-gradient-to-br from-green-50 to-teal-50">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center gap-4 mb-8">
            <TrendingUp className="h-12 w-12 text-green-700" />
            <h2 className="text-4xl font-bold">Nigerland Logistics & Marketing</h2>
          </div>
          <Card className="border-l-4 border-l-green-600">
            <CardContent className="p-8">
              <p className="text-xl text-gray-700 leading-relaxed">
                Our Logistics arm is headed by <strong className="text-green-700">Uduak Nkanga Ngwaba</strong>. The arm renders first class services in travels and tours as well as provision of marketing services to clients. With years of experience in logistics management and marketing strategy, Uduak ensures seamless service delivery and client satisfaction.
              </p>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* BUSINESS SOLUTIONS MODELS */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <Lightbulb className="h-16 w-16 mx-auto mb-4 text-orange-600" />
            <h2 className="text-4xl font-bold mb-4">Business Solutions Models</h2>
            <p className="text-xl text-gray-600">Innovative approaches to solving Business Place Problems (BPPs)</p>
          </div>
          <p className="text-lg text-gray-700 mb-12 text-center max-w-4xl mx-auto">
            In our bid to solve Business Place Problems (BPPs), Nigerland has developed <strong>Business Solutions Models (BSMs)</strong> that have been tested and proven effective across various organizations.
          </p>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { 
                title: 'ALL CATCH ALL Model', 
                desc: 'A comprehensive management and marketing model designed to capture all aspects of business operations, ensuring no critical element is overlooked.',
                icon: Target,
                color: 'blue'
              },
              { 
                title: 'CREATIVITY RATIO MODEL', 
                desc: 'An applied creativity test model scientifically designed to measure and enhance employees\' creative capabilities and innovation potential.',
                icon: Lightbulb,
                color: 'orange'
              },
              { 
                title: 'NIGERLAND RECRUITMENT GAMES MODEL (NRGM)', 
                desc: 'A revolutionary recruitment methodology aimed at identifying and recommending first-class personnel through engaging assessment games.',
                icon: Users,
                color: 'green'
              }
            ].map((model, idx) => (
              <Card key={idx} className={`border-t-4 hover:shadow-2xl transition-all duration-300 border-t-${model.color}-600`}>
                <CardContent className="p-8">
                  <div className={`h-16 w-16 bg-${model.color}-100 rounded-full flex items-center justify-center mb-6`}>
                    <model.icon className={`h-8 w-8 text-${model.color}-700`} />
                  </div>
                  <h3 className="font-bold text-2xl mb-4">{model.title}</h3>
                  <p className="text-gray-700 leading-relaxed">{model.desc}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* NIGERLAND PROJECTS */}
      <section id="projects" className="py-20 bg-gradient-to-br from-purple-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <Award className="h-16 w-16 mx-auto mb-4 text-purple-700" />
            <h2 className="text-4xl font-bold mb-4">Nigerland Projects</h2>
            <p className="text-xl text-gray-600">Transformative initiatives shaping communities</p>
          </div>
          {loading ? (
            <div className="text-center py-12"><p>Loading projects...</p></div>
          ) : (
            <div className="grid md:grid-cols-2 gap-12">
              {projects.map(project => (
                <Card key={project.id} className="hover:shadow-2xl transition-all duration-300 overflow-hidden">
                  {project.image && (
                    <img 
                      src={project.image} 
                      alt={project.title} 
                      className="w-full h-72 object-cover" 
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = 'none';
                      }}
                    />
                  )}
                  <CardContent className="p-8">
                    <h3 className="text-3xl font-bold mb-4 text-purple-700">{project.title}</h3>
                    <p className="text-gray-700 leading-relaxed text-lg">{project.description}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* NIGERLAND BOOKS FOUNDATION */}
      <section className="py-20 bg-gradient-to-r from-purple-100 via-blue-100 to-teal-100">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <Heart className="h-16 w-16 mx-auto mb-4 text-purple-700" />
            <h2 className="text-4xl font-bold mb-4">Nigerland Books Foundation</h2>
            <p className="text-xl text-gray-700">Instilling Morals, Ethics, and Values (MEVs)</p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            {['children1.jpg', 'children2.jpg', 'present1.jpg'].map((img, idx) => (
              <img 
                key={idx}
                src={`/images/foundation/${img}`} 
                alt="Foundation activities" 
                className="w-full h-64 object-cover rounded-2xl shadow-2xl hover:scale-105 transition-transform duration-300" 
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/images/placeholder.jpg';
                }}
              />
            ))}
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-2xl">
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 leading-relaxed text-lg mb-6">
                <strong className="text-purple-700 text-xl">NIGERLAND BOOKS FOUNDATION (NBF)</strong> is a knowledge-based NGO that seeks to instill Morals, Ethics and Values (MEVs) which are largely the bane of development.
              </p>
              
              <div className="grid md:grid-cols-2 gap-8 my-8">
                <div className="bg-purple-50 rounded-xl p-6">
                  <h3 className="font-bold text-2xl mb-4 text-purple-700">Our Mission</h3>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start"><span className="text-purple-600 mr-2">\u2022</span>Eradicating illiteracy</li>
                    <li className="flex items-start"><span className="text-purple-600 mr-2">\u2022</span>Promoting reading culture</li>
                    <li className="flex items-start"><span className="text-purple-600 mr-2">\u2022</span>Using education to fight hunger & ignorance</li>
                    <li className="flex items-start"><span className="text-purple-600 mr-2">\u2022</span>Enhancing creative thinking</li>
                  </ul>
                </div>
                <div className="bg-blue-50 rounded-xl p-6">
                  <h3 className="font-bold text-2xl mb-4 text-blue-700">Our Goals</h3>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start"><span className="text-blue-600 mr-2">\u2022</span>Building future leaders</li>
                    <li className="flex items-start"><span className="text-blue-600 mr-2">\u2022</span>Enhancing leadership efficiency</li>
                    <li className="flex items-start"><span className="text-blue-600 mr-2">\u2022</span>Growing knowledge & awareness</li>
                    <li className="flex items-start"><span className="text-blue-600 mr-2">\u2022</span>Building capacity</li>
                  </ul>
                </div>
              </div>

              <div className="bg-gradient-to-r from-purple-700 to-blue-700 text-white p-8 rounded-2xl my-8">
                <p className="text-lg italic leading-relaxed mb-4">
                  "Possession of MEVs = RIGHT ATTITUDE = REFLECTIVE ASSIMILATION = DESIRED OUTPUT"
                </p>
              </div>

              <p className="text-gray-700 leading-relaxed mb-4">
                NBF operates on the premise that a well brought up person cannot deviate from his manners when he gets into leadership positions. <strong>Catching them young is therefore a MUST for NBF.</strong>
              </p>
              
              <div className="bg-purple-50 border-l-4 border-purple-700 p-6 my-6">
                <p className="text-gray-800 leading-relaxed">
                  <strong className="text-purple-700 text-lg">Kelechi Ngwaba</strong> is the Promoter of Nigerland Books Foundation. He is a Fellow of the Institute of Chartered Accountants of Nigeria (FCA), a Management Consultant and a Writer. His published works include <strong>THE GENERATIONS (2007)</strong>, <strong>THREE FEET TALL (2011)</strong>, and <strong>NEVER AGAIN (2020)</strong>, along with numerous books for primary school pupils.
                </p>
              </div>

              <p className="text-gray-700 leading-relaxed">
                <strong>Foundation Members:</strong> Dr (Mrs) Ada Onyebuenyi, Mrs Uduak Nkanga Ngwaba, Charles Chukwuonye, Urenna Ajuzie, Adaeze Ezenwabekee, and Dr Edwin Mboho, along with a host of Consultants called upon from time to time to partake in her programmes and projects.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CALL TO ACTION */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-indigo-700 text-white">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">Welcome to Nigerland! This is Our World!</h2>
          <p className="text-xl text-blue-100 mb-8">
            Join us in our mission to develop men, create innovative solutions, and transform society for the better.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/contact" className="inline-block px-8 py-4 bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold rounded-lg transition">
              Get In Touch
            </a>
            <a href="/trainings" className="inline-block px-8 py-4 bg-white/10 hover:bg-white/20 border-2 border-white font-bold rounded-lg transition">
              Explore Training
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};
